import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Badge } from "react-bootstrap";

const TicketModal = ({ show, handleClose, onSave, ticket }) => {
  const isEdit = !!ticket;

  const [formData, setFormData] = useState({
    title: "",
    category: "",
    subject: "",
    description: "",
    priority: "",
    status: "",
  });

  const [users, setUsers] = useState([]);
  const [input, setInput] = useState("");
  const [showInput, setShowInput] = useState(false);

  // ✅ Prefill data in edit mode
  useEffect(() => {
    if (ticket) {
      setFormData({
        title: ticket.title || "",
        category: ticket.category || "",
        subject: ticket.subject || "",
        description: ticket.description || "",
        priority: ticket.priority || "",
        status: ticket.status || "",
      });

      setUsers(ticket.users || ["Edgar Hansel"]);
    } else {
      setFormData({
        title: "",
        category: "",
        subject: "",
        description: "",
        priority: "",
        status: "",
      });
      setUsers([]);
    }
  }, [ticket]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddUser = () => {
    if (input.trim() !== "") {
      setUsers([...users, input.trim()]);
      setInput("");
      setShowInput(false);
    }
  };

  const handleRemove = (index) => {
    setUsers(users.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    const finalData = {
      ...formData,
      users,
      id: ticket ? ticket.id : Date.now(),
    };

    onSave(finalData);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: "600" }}>
          {isEdit ? "Edit Ticket" : "Add Ticket"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter Title"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Event Category</Form.Label>
            <Form.Select
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option>Select</option>
              <option>Hardware Issues</option>
              <option>Software Issues</option>
              <option>IT Support</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Subject</Form.Label>
            <Form.Control
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Enter Subject"
            />
          </Form.Group>

          {/* ASSIGN TO */}
          <Form.Group className="mb-3">
            <Form.Label>Assign To</Form.Label>

            <div
              style={{
                border: "1px solid #ddd",
                borderRadius: "6px",
                padding: "6px",
                display: "flex",
                flexWrap: "wrap",
                gap: "6px",
              }}
            >
              {users.map((user, index) => (
                <Badge key={index} bg="light" text="dark">
                  {user}
                  <span
                    style={{ cursor: "pointer", marginLeft: 6 }}
                    onClick={() => handleRemove(index)}
                  >
                    ×
                  </span>
                </Badge>
              ))}

              {showInput ? (
                <input
                  autoFocus
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onBlur={handleAddUser}
                  onKeyDown={(e) => e.key === "Enter" && handleAddUser()}
                  style={{ border: "none", outline: "none" }}
                />
              ) : (
                <span
                  onClick={() => setShowInput(true)}
                  style={{ color: "#6c757d", cursor: "pointer" }}
                >
                  Add new
                </span>
              )}
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Priority</Form.Label>
            <Form.Select
              name="priority"
              value={formData.priority}
              onChange={handleChange}
            >
              <option>Select</option>
              <option>Low</option>
              <option>Medium</option>
              <option>High</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option>Select</option>
              <option>Open</option>
              <option>Closed</option>
              <option>On Hold</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between">
        <Button
          onClick={handleClose}
          style={{ background: "#e5e7eb", border: "none", color: "#111" }}
        >
          Cancel
        </Button>

        <Button
          onClick={handleSubmit}
          style={{ background: "#ff6b00", border: "none" }}
        >
          {isEdit ? "Update Ticket" : "Add Ticket"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TicketModal;